import PropTypes from 'prop-types';
import { valueSelector } from '../selectors';
import entityComposition from '../../common/classes/entityComposition';

/**
 * Dev/test utility that deliberately throws during React render so the
 * top-level ErrorBoundary fallback can be exercised.
 *
 * Unlike an infusion thrown from a click handler (which the form behavior
 * system catches and surfaces as a toast), a throw during render is caught
 * by React error boundaries.
 *
 * Gated by content: it only throws once `value` (bound to a content path) is
 * a non-empty string, so the enclosing report renders normally until the demo
 * is "armed" by entering an error message.
 *
 * WARNING: Do not use in production customer forms. Intended only for RB
 * example reports (csv #2459) and similar internal testing scenarios.
 */
const RenderErrorDemo = ({
  value: _value = ''
}) => {
  if (typeof _value === 'string' && _value.length > 0) {
    throw new Error(_value);
  }
  return null;
};
RenderErrorDemo.propTypes = {
  value: PropTypes.string
};
export { RenderErrorDemo as UncomposedRenderErrorDemo };
export default entityComposition(RenderErrorDemo, [], {
  value: valueSelector
});